export default __webpack_public_path__ + "static/media/new_order.80c3f258.mp3";